<template>
    <div style="height: 100vh">
        <div style="background: #B7B7B7; color: #000000;margin: 50px;text-align: center;">
            {{ data }}
        </div>
        <div class="text-center" style="margin-top:50px">
            <button type="button" class="btn btn-primary" @click="testGame()">
                Test the game
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: this.$route.params.data ? this.$route.params.data : ''
            }
        },

        methods: {
            testGame() {
                this.$router.push({
                    name: 'game',
                    key: '_' + Math.random().toString(36).substr(2, 9),
                    query: {
                        playback: true
                    }
                })
            }
        }
    }
</script>